import { FEATURE_TYPE } from '@/constants/features';
import { UsePointToProjectionResult } from '@/utils/map/usePointToProjection';
import { Feature } from 'ol';
import Point from 'ol/geom/Point';
import { Icon, Style } from 'ol/style';
import type { MarkerImage } from 'minerva-plugin-api';

export const getMarkerImageFeatures = (
  markers: MarkerImage[],
  { pointToProjection }: { pointToProjection: UsePointToProjectionResult },
): Feature<Point>[] =>
  markers.map(marker => {
    const feature = new Feature<Point>({
      geometry: new Point(pointToProjection({ x: marker.x, y: marker.y })),
      id: marker.id,
      type: FEATURE_TYPE.IMAGE_MARKER,
    });
    feature.setStyle(
      new Style({
        image: new Icon({
          src: marker.url,
          width: marker.width,
          height: marker.height,
        }),
      }),
    );
    return feature;
  });
